<template>
    <div class="carousel-wrapper">
        <div class="row">
            <div class="col-12 offers">
                <custom-slick ref="slickBody" :options="slickOptions" :class="'body-slick' + vhtype">
                    <div :key="'all'" class="card-wrap">
                        <div class="card-wrap__link" @click="flipAll()">
                            <div class="card-wrap__link__image"
                                 :style="{ backgroundImage:'url(' + getImage('all', this.all) + ')' }"
                                 >
                            </div>
                            <div class="card-wrap__link__text">
                                All
                            </div>
                        </div>
                    </div>
                    <div :key="icon.id" v-for="icon in iconList" class="card-wrap">
                        <div class="card-wrap__link" @click="flipSelection(icon.id)">
                            <div class="card-wrap__link__image"
                                 :style="{ backgroundImage:'url(' + getImage(icon.name, isSelected(icon.id)) + ')' }"
                                 >

                            </div>
                            <div class="card-wrap__link__text">
                                {{icon.name | bodyStyles}}
                            </div>
                        </div>
                    </div>
                </custom-slick>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomSlick from "../CustomSlick";
    export default {
        props: [
            'icons',
            'type',
            'value',
            'vhtype'
        ],
        components: {
            CustomSlick,
        },
        name: "CarouselIcons",
        data: function() {
            return {
                slickOptions: {
                    infinite: false,
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    dots: true,
                    dotsClass: "slick-dots d-none d-md-flex",
                    appendArrows: '.body-slick' + this.vhtype + ' + .slick-paging',
                    appendDots: '.body-slick' + this.vhtype + ' + .slick-paging',
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        }
                    ]
                },
            }
        },
        computed: {
            iconList: function() {
                return (this.icons) ? this.icons : [];
            },
            selectedValues: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            },
            all: function(){
                return (this.value.length === 0);
            }
        },
        methods: {
            getImage: function(name, active) {
                return require('@/assets/images/' + this.type + '/' + this.prepName(name) + ((active) ? '-active': '') + '.svg');
            },
            prepName: function(value) {
                return value.trim().replace(/[\s/]/g, '-').toLowerCase();
            },
            isSelected: function(id) {
                return (undefined !== this.selectedValues.find(function(value) {
                    return value === id;
                }));
            },
            flipSelection: function(id){
                if (undefined === this.selectedValues.find(function(value) {
                    return value === id;
                })) {
                    this.selectedValues = [...this.selectedValues, id];
                } else {
                    this.selectedValues = this.selectedValues.filter(function(value) {
                        return value !== id;
                    })
                }
            },
            flipAll: function() {
                this.selectedValues = [];
            }
        }
    }
</script>

<style lang="stylus">
    .carousel-wrapper
        margin: 40px auto 15px
        min-width 100px
        .card-wrap
            padding 0 5px
            text-align center
            &__link
                text-align center
                cursor pointer
                color #004666
                font-family "VWAGTheSansRegular", Arial, sans-serif
                font-size 18px
                min-width 135px
                &__text
                    margin-top 15px
                &__image
                    text-align center
                    width 100%
                    height 100px
                    margin 0 auto;
                    background-position center
                    background-repeat no-repeat
                    background-size 100px

</style>